import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe, AuthFacade, ResourcesService } from '@mitsubishi/core';
import { ConfigurationAlertsDialogComponent } from '@mitsubishi/project/shared';
import { PerformanceMessage } from '@mitsubishi/shared/data-access';
import { IconComponent, SectionTitleComponent } from '@mitsubishi/shared/ui';
import { DialogService } from '@mitsubishi/ui/dialog';

import { FieldWrapper } from '@ngx-formly/core';

import { FormlyTableWrapperColumn } from '../../models/table-wrapper-column';
import { ApmFormlyService } from '../../services/formly.service';
import { TableWrapperCellComponent } from './table-wrapper-cell/table-wrapper-cell.component';

@Component({
  selector: 'apm-table-wrapper',
  templateUrl: './table-wrapper.component.html',
  styleUrls: ['./table-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableWrapperCellComponent, MatTooltip, NgClass, SectionTitleComponent, ApmTranslatePipe, IconComponent],
})
export class TableWrapperComponent extends FieldWrapper implements OnInit {
  canDebug = inject(AuthFacade).canDebug;

  resourcesService = inject(ResourcesService);
  dialogService = inject(DialogService);
  formlyService = inject(ApmFormlyService);

  tableColumns: FormlyTableWrapperColumn[] = [];

  isFirst = false;

  ngOnInit() {
    if (this.field.props && this.field.props['tableColumns']) {
      this.tableColumns = this.field.props['tableColumns'];
    }
    this.isFirst = this.field?.parent?.fieldGroup?.findIndex(f => f.key === this.field.key) === 0;
  }

  showErrorMessages(errorsResource: number[]) {
    const errorMessages: PerformanceMessage[] = errorsResource.map((error: any) => {
      return {
        code: '',
        description: '',
        descriptionId: error.id,
        messageType: 2,
        parameters: [error.performanceValue, error.performanceUserValue],
      };
    });

    const data = {
      messages: errorMessages,
      title: this.resourcesService.getTextResource('445235'),
    };
    this.dialogService.openDialog(ConfigurationAlertsDialogComponent, 'md', data);
  }

  onColumnClick(column: FormlyTableWrapperColumn) {
    this.formlyService.dispatchEvent({
      event: 'TABLE_HEADER_COLUMN_CLICK',
      data: column,
    });
  }
}
